import React, { Component } from "react";
import classnames from "classnames";

import { range } from "@formant/core/common/range";
import { IDeviceTeleopConfiguration } from "@formant/core/model/IDeviceTeleopConfiguration";
import { IRtcStream } from "@formant/core/model/IRtcStream";

import { ITeleopModuleProps } from "..";
import { deviceStore, operateStore } from "../../../../stores";
import { TabPagination } from "../../../common/TabPagination";
import * as styles from "./index.scss";
import { TeleopCommandButton } from "./TeleopCommandButton";

export interface ITeleopCommandsProps extends ITeleopModuleProps {
    configuration: IDeviceTeleopConfiguration;
}

const buttonsPerTab = 4;

export class TeleopCommands extends Component<ITeleopCommandsProps> {
    public render() {
        const { configuration, className, session } = this.props;
        const streams: IRtcStream[] = this.props.streams || [];

        const firstJoystick = configuration.joysticks?.[0];
        const disableGamepadAndKeyboardValue =
            firstJoystick?.disableGamepadAndKeyboard;
        const armed =
            operateStore.armed &&
            !operateStore.editingDevice &&
            !operateStore.feedbackVisible &&
            !deviceStore.issuingCommand &&
            !operateStore.usingTerminal;

        const tabCount: number = Math.ceil(streams.length / buttonsPerTab);

        const pages = range(0, tabCount).map(i => {
            const start = i * buttonsPerTab;
            const end = start + buttonsPerTab;
            const buttons = streams.slice(start, end).map((stream, index) => {
                const rosStatusTopic = (configuration.rosStreams || []).find(
                    _ => stream.streamName === _.topicName,
                )?.statusTopic;
                const buttonColor = (configuration.rosStreams || []).find(
                    _ => stream.streamName === _.topicName,
                )?.buttonColor;

                const customButtonsTopic =
                    stream.streamName === "Buttons"
                        ? stream.streamName
                        : undefined;

                return (
                    <TeleopCommandButton
                        key={start + index}
                        index={start + index}
                        stream={stream}
                        session={session}
                        disabled={!armed}
                        statusTopic={rosStatusTopic || customButtonsTopic}
                        statusLabel={stream.label}
                        backgroundColor={buttonColor}
                        disableGamepadInput={disableGamepadAndKeyboardValue}
                        disableKeyboardInput={disableGamepadAndKeyboardValue}
                        configuration={configuration}
                    />
                );
            });

            return (
                <div key={i} className={styles.page}>
                    {buttons}
                </div>
            );
        });

        const hasPagination = pages.length > 0;

        return (
            <TabPagination
                className={classnames(
                    styles["teleop-commands"],
                    hasPagination && styles.pagination,
                    className,
                )}
                pages={pages}
                position="bottom"
            />
        );
    }
}
